import { observer } from "mobx-react";
import { useAppSettingStore } from "../SettingStores/AppSettingPageStore";
import { TextFieldSetter } from "Views/Components/TextBox/TextFieldSetter";
import ToggleSwitch from "Views/Components/ToggleSwitch/ToggleSwitch";
import { TextArea } from "Views/Components/TextArea/TextArea";
import { Validation } from "Hooks/useValidation";
import { Tooltip } from "Views/Components/Tooltip/Tooltip";

type Props = {
	validation: Validation;
}

export const CreditProviderForm: React.FunctionComponent<Props> = observer(({
	validation,
}) => {
	const { creditProviderItemStore: { creditProvider, updateCreditProvider } } = useAppSettingStore();

	return (
		<>
			<TextFieldSetter
				label="Name"
				value={creditProvider.name}
				setValue={value => updateCreditProvider({ ...creditProvider, name: value })}
				isRequired
				errors={validation.get("name")}
			/>
			<label id="isActive" htmlFor="isActive">State
				<Tooltip
					id="isActive-tooltip"
					content="Note: Disabling the provider will also disable the products associated with it."
				/>
			</label>
			<ToggleSwitch
				model={creditProvider}
				modelProperty="isActive"
				label={"Active/Inactive"}
			/>
			<TextArea
				label="Description"
				model={creditProvider}
				modelProperty="description"
				isRequired
				onAfterChange={event => {
					updateCreditProvider({...creditProvider, description: event.target.value});
				}}
				errors={validation.get("description")}
				tooltip="The description of the credit provider."
			/>
		</>
	)
})